import { notifications } from '@mantine/notifications';
import type { PosStreamEvent } from 'shared-models/browser';
import { subscribeSharedTicker } from '../../../../utils/shared-ticker';

type QueueJob = Extract<PosStreamEvent, { type: 'print_job.updated' }>['job'];

export function createQueuedPrintWarning(employeeId: number | null) {
  const pending = new Map<number, QueueJob>();
  const handled = new Set<number>();
  let active = false;
  let unsubscribe: (() => void) | undefined;
  const notificationId = 'actor-queued-print-warning';

  const tick = () => {
    for (const [jobId, job] of pending) {
      if (Date.now() - new Date(job.createdAt).getTime() < 5000) continue;
      pending.delete(jobId);
      handled.add(jobId);
      if (active) continue;
      active = true;
      notifications.show({
        id: notificationId,
        color: 'orange',
        message: 'ההזמנה נכנסה לתור ההדפסות, אנא בדוק תקינות מדפסות במידה ולא מודפס עד דקה מתצוגת התראה זו.',
        autoClose: 10000,
        onClose: () => { active = false; },
      });
    }
    if (pending.size === 0) {
      unsubscribe?.();
      unsubscribe = undefined;
    }
  };

  return {
    update(job: QueueJob) {
      if (employeeId == null || job.createdByEmployeeId !== employeeId) return;
      if (job.status !== 'queued') {
        pending.delete(job.id);
        handled.add(job.id);
      } else if (!handled.has(job.id)) {
        pending.set(job.id, job);
      }
      if (pending.size > 0 && !unsubscribe) unsubscribe = subscribeSharedTicker(1000, tick);
    },
    dispose() {
      unsubscribe?.();
      pending.clear();
      handled.clear();
      if (active) notifications.hide(notificationId);
    },
  };
}